import * as yup from "yup";
import isEmail from 'validator/es/lib/isEmail';

yup.addMethod(yup.string, "emailValidatorJs", function (errorMessage) {
    return this.test(`is-email-validator-js`, errorMessage, function (value) {
        const { path, createError } = this;
        return (
            isEmail(value) ||
            createError({ path, message: errorMessage })
        );
    });
});
